import { genericPage, getServerSidePropsHelper } from 'components/corporatiu/Page';
import { useRouter } from 'next/router';

const path = ['web', process.env.FOLDER_LAYOUTS_CORPORATIU, 'tv3', 'programacio'];

const Pagina = (props) => {
    const router = useRouter();
    return genericPage(props, router, path);
};

export async function getServerSideProps(context) {
    const { slug } = context.query;
    let idCanal = '';
    switch (slug) {
        case 'canal-tv3':
            idCanal = 'CAD_TV3';
            break;
        case 'canal-3catinfo-tv':
            idCanal = 'CAD_324';
            break;
        case 'canal-33':
            idCanal = 'CAD_C33';
            break;
        case 'canal-esport3':
            idCanal = 'CAD_ES3';
            break;
        case 'canal-sx3':
            idCanal = 'CAD_SX3';
            break;
        case 'canal-tv3cat':
            idCanal = 'CAD_TVI';
            break;
        default:
            return {
                notFound: true
            };
    }
    const options = {
        slugs: path,
        id: idCanal
    };
    return getServerSidePropsHelper(context, options);
}

export default Pagina;
